import { Action } from '@ngrx/store';

export class CustomerWalletAction implements Action {

    public static getCustomerWallet = '[CustomerWallet] get_customer_wallet';
    public static getCustomerWalletError = '[CustomerWallet] get_customer_wallet_error';
    public static getCustomerWalletSuccess = '[CustomerWallet] get_customer_wallet_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
